import React from "react";

import { formatDecimal2 } from "~/utils";
import { HealthSummary } from "../Shared";

interface BodyWeightData {
  date: string;
  value: number;
}

interface HourlyBodyWeightData {
  datetime: string;
  hour: number;
  value: number;
}

interface BodyWeightSummaryProps {
  filteredData: (BodyWeightData | HourlyBodyWeightData)[];
  metadata: {
    avg: number;
    min: number;
    max: number;
  } | null;
  handlePrevious: () => void;
  handleNext: () => void;
  onDateSelect: (date: Date) => void;
  selectedDate: Date;
  selectedRange: string;
}

export const BodyWeightSummary: React.FC<BodyWeightSummaryProps> = ({
  filteredData,
  metadata,
  handlePrevious,
  handleNext,
  onDateSelect,
  selectedDate,
  selectedRange,
}) => {
  const getSummaryValues = (metadata: { avg: number; min: number; max: number } | null, _filteredData: (BodyWeightData | HourlyBodyWeightData)[]) => [
    {
      label: "Min",
      value: formatDecimal2(metadata?.min ?? 0),
      color: "#3b82f6", // blue-500
      unit: "lbs",
    },
    {
      label: "Avg",
      value: formatDecimal2(metadata?.avg ?? 0),
      color: "#22c55e", // green-500
      unit: "lbs",
    },
    {
      label: "Max",
      value: formatDecimal2(metadata?.max ?? 0),
      color: "#ef4444", // red-500
      unit: "lbs",
    },
  ];

  return (
    <HealthSummary
      filteredData={filteredData}
      metadata={metadata}
      handlePrevious={handlePrevious}
      handleNext={handleNext}
      onDateSelect={onDateSelect}
      selectedDate={selectedDate}
      selectedRange={selectedRange}
      getSummaryValues={getSummaryValues}
    />
  );
};